import * as React from 'react';

import { Button, Modal } from 'antd';

type PermanentAccessAlertModalProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const PermanentAccessAlertModal = ({ isOpen, handleClose }: PermanentAccessAlertModalProps) => {
  return (
    <Modal
      open={isOpen}
      onCancel={() => handleClose()}
      width={400}
      title={
        <span className='flex gap-2 text-[1.2rem]'>
          <img src='/img/alert-icon.svg' width='25' /> <span>Acesso permanente</span>
        </span>
      }
      footer={
        <Button onClick={() => handleClose()} type='primary' size='middle'>
          Entendi
        </Button>
      }
    >
      <p className='mb-[10px]'>
        <span className='text-base'>
          Ativar o acesso permanente garante que o cliente continue com acesso
          <span className='font-bold'> mesmo após o fim do contrato.</span>
        </span>
      </p>
    </Modal>
  );
};

export default PermanentAccessAlertModal;
